export default function CookiePolicy() {
    return (
        <div className="container-tight max-w-3xl py-16 lg:py-24" data-testid="cookie-policy-page">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
                Legal
            </p>
            <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 dark:text-slate-50">
                Cookie Policy
            </h1>
            <p className="mt-4 text-sm text-slate-500">Last updated: 11 June 2026</p>

            <div className="prose prose-slate dark:prose-invert mt-10 max-w-none text-slate-600 dark:text-slate-400 leading-relaxed space-y-6">
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        1. What Are Cookies
                    </h2>
                    <p>
                        Cookies are small text files stored on your device when you visit
                        a website. TenderTrackAI uses cookies and similar technologies
                        (such as browser local storage) to operate the platform securely
                        and improve your experience.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        2. Cookies We Use
                    </h2>
                    <p>
                        <strong>Essential cookies (always on):</strong> authentication and
                        session tokens that keep you securely logged in, and preference
                        storage such as your light/dark theme choice. The platform cannot
                        function without these.
                    </p>
                    <p>
                        <strong>Payment cookies:</strong> when you make a payment, our
                        payment partner Razorpay may set cookies necessary to process the
                        transaction securely and prevent fraud. These are governed by
                        Razorpay&apos;s own privacy and cookie policies.
                    </p>
                    <p>
                        <strong>Analytics cookies (optional):</strong> we may use
                        privacy-respecting, aggregated analytics to understand product
                        usage. We do not use advertising or cross-site tracking cookies.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        3. Managing Cookies
                    </h2>
                    <p>
                        You can block or delete cookies through your browser settings at
                        any time. Note that blocking essential cookies will prevent you
                        from logging in and using the dashboard.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        4. Changes to This Policy
                    </h2>
                    <p>
                        We may update this Cookie Policy from time to time. Material
                        changes will be announced on this page with a revised
                        &ldquo;Last updated&rdquo; date.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        5. Contact
                    </h2>
                    <p>
                        Questions about cookies or privacy? Email
                        privacy@tendertrackai.com or write to TenderTrackAI Technologies
                        Pvt. Ltd., Indiranagar, Bengaluru 560038, India.
                    </p>
                </section>
            </div>
        </div>
    );
}
